import * as React from 'react'
import { Map } from 'react-loadable'

export const prefetch = () =>
  import('./BlacklistPage')

export const BlacklistPage = Map({
  loader: {
    Module: prefetch
  },
  loading: () => null,
  render: ({ Module }, props) => <Module.default {...props} />
})



// WEBPACK FOOTER //
// ./src/routes/BlacklistPage/index.js